export const dosdoc_details_arr = [
    {
      field: "Details",
      arr: [
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Source",
              field: "source",
              type: "text",
              className: "col-6",
            },
            {
              title: "User Name",
              field: "username",
              type: "text",
              className: "col-6",
            },
            {
              title: "User Company",
              field: "usercompany",
              type: "text",
              className: "col-6",
            },
            {
              title: "User Email",
              field: "useremail",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Assignment Question",
              field: "assignmentquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Original Lender",
              field: "originallender",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Single Lender Question",
              field: "singlelenderquestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "Lender State",
              field: "lenderstate",
              type: "text",
              className: "col-6",
            },
            {
              title: "Lender Name",
              field: "lendername",
              type: "text",
              className: "col-6",
            },
            {
              title: "Lender Address",
              field: "lenderaddress",
              type: "text",
              className: "col-6",
            },
            {
              title: "Lender Officer",
              field: "lenderofficer",
              type: "text",
              className: "col-6",
            },
            {
              title: "Lender Rep Title",
              field: "lenderreptitle",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "State Question",
              field: "statequestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "Property Address",
              field: "propertyaddress",
              type: "text",
              className: "col-6",
            },
            {
              title: "County",
              field: "countyprop1",
              type: "text",
              className: "col-6",
            },
            {
              title: "Prop",
              field: "prop100",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Second Property Question",
              field: "secondpropertyquestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "Second Property Address",
              field: "secondpropertyaddress",
              type: "text",
              className: "col-6",
            },
            {
              title: "County",
              field: "countyprop2",
              type: "text",
              className: "col-6",
            },
            {
              title: "Prop200",
              field: "prop100",
              type: "text",
              className: "col-6",
            },
            {
              title: "Borrower Name",
              field: "borrowername",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Borrower Entity Question",
              field: "borrowerentityquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Borrower Type",
              field: "Borrower_Type",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Borrower Sub Entity Question",
              field: "borrsubentityquestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "Sub Entity name",
              field: "subentityname", 
              type: "text",
              className: "col-6",
            },
            {
              title: "Borrower Address",
              field: "borroweraddress",
              type: "text",
              className: "col-6",
            },
            {
              title: "First Signer Name",
              field: "firstsignername",
              type: "text",
              className: "col-6",
            },
            {
              title: "First Signer Title",
              field: "firstsignertitle",
              type: "text",
              className: "col-6",
            },
            {
              title: "Second Signer Name",
              field: "secondsignername",
              type: "text",
              className: "col-6",
            },
            {
              title: "Second Signer Title",
              field: "secondsignertitle",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Coborrower Question",
              field: "coborrowerquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Coborrower Name",
              field: "coborrowername",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Coborrower Entity Question",
              field: "coborrowerentityquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Coborrower Entity Type",
              field: "coborrowerentitytype",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Coborrower Sub Entity Question",
              field: "coborrsubentityquestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "Coborrower Sub Name",
              field: "coborrsubname",
              type: "text",
              className: "col-6",
            },
            {
              title: "Coborrower Address",
              field: "coborrroweraddress",
              type: "text",
              className: "col-6",
            },
            {
              title: "Coborrower First Signer Name",
              field: "coborrfirstsignername",
              type: "text",
              className: "col-6",
            },
            {
              title: "Coborrower First Signer Title",
              field: "coborrfirstsignertitle",
              type: "text",
              className: "col-6",
            },
            {
              title: "Coborrower Second Signer Name",
              field: "coborrsecondsignername",
              type: "text",
              className: "col-6",
            },
            {
              title: "Coborrower Second Signer Title",
              field: "coborrsecondsignertitle",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Guarantor Question",
              field: "guarantorquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "First Guarantor Name",
              field: "firstguarantorname",
              type: "text",
              className: "col-6",
            },
            {
              title: "Second Guarantor Name",
              field: "secondguarantorname",
              type: "text",
              className: "col-6",
            },
            {
              title: "Third Guarantor Name",
              field: "thirdguarantorname",
              type: "text",
              className: "col-6",
            },
            {
              title: "Fourth Guarantor Name",
              field: "fourthguarantorname",
              type: "text",
              className: "col-6",
            },
            {
              title: "Loan Number",
              field: "loanno",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Business Purpose Question",
              field: "businesspurposequestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "Document Date",
              field: "docdate",
              type: "date",
              className: "col-6",
            },
            {
              title: "Sec Inst Name secinstnameprop1",
              field: "Sec_Inst_Name_Property1",
              type: "text",
              className: "col-6",
            },
            {
              title: "Document Date Property1",
              field: "docdateprop1",
              type: "text",
              className: "col-6",
            },
            {
              title: "Recording Date Property1",
              field: "recordingdateprop1",
              type: "date",
              className: "col-6",
            },
            {
              title: "ID Property1",
              field: "idprop1",
              type: "text",
              className: "col-6",
            },
            {
              title: "Recorder Name Property1",
              field: "recordernameprop1",
              type: "text",
              className: "col-6",
            },
            {
              title: "Secinst name prop2",
              field: "secinstnameprop1",
              type: "text",
              className: "col-6",
            },
            {
              title: "Doc date prop2",
              field: "docdateprop2",
              type: "text",
              className: "col-6",
            },
            {
              title: "Recording date prop2",
              field: "recordingdateprop2",
              type: "date",
              className: "col-6",
            },
            {
              title: "Note title",
              field: "notetitle",
              type: "text",
              className: "col-6",
            },
            {
              title: "Guaranty title",
              field: "guarantytitle",
              type: "text",
              className: "col-6",
            },
            {
              title: "Guaranty date",
              field: "guarantydate",
              type: "date",
              className: "col-6",
            },
            {
              title: "Mod Dates",
              field: "moddates",
              type: "date",
              className: "col-6",
            },
            {
              title: "Loan amount",
              field: "loanamount",
              type: "text",
              className: "col-6",
            },
            {
              title: "Current rate",
              field: "currentrate",
              type: "number",
              className: "col-6",
            },
            {
              title: "Initial payment amount",
              field: "initialpaymentamount",
              type: "number",
              className: "col-6",
            },
            {
              title: "Maturity date",
              field: "maturitydate",
              type: "date",
              className: "col-6",
            },
            {
              title: "Current balance",
              field: "currentbalance",
              type: "number",
              className: "col-6",
            },
            {
              title: "As of date",
              field: "asofdate",
              type: "date",
              className: "col-6",
            },
            {
              title: "Interest owed",
              field: "interestowed",
              type: "number",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Other Amounts Question",
              field: "otheramountsquestion",
              type: "textarea",
              className: "col-12",
            },
            {
              title: "First Other Owed",
              field: "firstotherowed",
              type: "text",
              className: "col-6",
            },
            {
              title: "First Other Amount",
              field: "firstotheramount",
              type: "number",
              className: "col-6",
            },
            {
              title: "Second Other Owed",
              field: "secondotherowed",
              type: "text",
              className: "col-6",
            },
            {
              title: "Second Other Amount",
              field: "secondotheramount",
              type: "number",
              className: "col-6",
            },
            {
              title: "Third Other owed",
              field: "thirdotherowed",
              type: "text",
              className: "col-6",
            },
            {
              title: "Third Other Amount",
              field: "thirdotheramount",
              type: "number",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "New Money Question",
              field: "newmoneyquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "New Money",
              field: "newmoney",
              type: "number",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Maturity Date question",
              field: "maturitydatequestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "New Maturity Date",
              field: "newmaturitydate",
              type: "date",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Rate Change Question",
              field: "ratechangequestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "New Rate",
              field: "newrate",
              type: "number",
              className: "col-6",
            },
            {
              title: "Rate Change Date",
              field: "ratechangedate",
              type: "date",
              className: "col-6",
            },
            {
              title: "New Payment",
              field: "newpayment",
              type: "number",
              className: "col-6",
            },
            {
              title: "New Payment Date",
              field: "newpaymentdate",
              type: "date",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Deferral Question",
              field: "deferralquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Deferred Items",
              field: "deferreditems",
              type: "text",
              className: "col-6",
            },
            {
              title: "Deferred Items Total",
              field: "deferreditemstotal",
              type: "number",
              className: "col-6",
            },
            {
              title: "Deferral Date",
              field: "deferraldate",
              type: "date",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "New Fee Question",
              field: "newfeequestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "New Fee Name",
              field: "newfeename",
              type: "text",
              className: "col-6",
            },
            {
              title: "New Fee Amount",
              field: "newfeeamount",
              type: "number",
              className: "col-6",
            },
            {
              title: "Payee Of Mod Fee",
              field: "payeeofmodfee",
              type: "text",
              className: "col-6",
            },
            {
              title: "Due Date New Fee",
              field: "duedatenewfee",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Fee Schedule Question",
              field: "feeschedulequestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Other Changes",
              field: "otherchanges",
              type: "text",
              className: "col-6",
            },
            {
              title: "Conditions",
              field: "conditions",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Money Due Question",
              field: "moneyduequestion",
              type: "textarea",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12 border-bottom",
          arr: [
            {
              title: "Other Conditions Question",
              field: "otherconditonsquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Money Due Amount",
              field: "moneydueamount",
              type: "number",
              className: "col-6",
            },
            {
              title: "Money Due Reason",
              field: "moneyduereason",
              type: "text",
              className: "col-6",
            },
          ],
        },
        {
          section: "",
          className: "col-12",
          arr: [
            {
              title: "Recording Question",
              field: "recordingquestion",
              type: "textarea",
              className: "col-6",
            },
            {
              title: "Memo Address",
              field: "memoaddress",
              type: "text",
              className: "col-6",
            },
            {
              title: "Legal Description",
              field: "legaldesc",
              type: "text",
              className: "col-6",
            },
            {
              title: "APN Of Collateral",
              field: "apnofcollateral",
              type: "text",
              className: "col-6",
            },
            {
              title: "Legal Property2",
              field: "legalprop2",
              type: "text",
              className: "col-6",
            },
            {
              title: "APN Second Property",
              field: "apnsecondproperty",
              type: "text",
              className: "col-6",
            },
            {
              title: "Trustee Name",
              field: "trusteename",
              type: "text",
              className: "col-6",
            },
            {
              title: "Terms Of Service",
              field: "termsofservice",
              type: "text",
              className: "col-6",
            },
            {
              title: "Total Other Amounts",
              field: "totalotheramounts",
              type: "number",
              className: "col-6",
            },
            {
              title: "Total Owed",
              field: "totalowed",
              type: "number",
              className: "col-6",
            },
            {
              title: "New Principal",
              field: "newprincipal",
              type: "number",
              className: "col-6",
            },
          ],
        },
      ],
    },
];